import React from 'react';
import { SeedPaths } from './Seed';

/** SVG version of the product cover, used until the real mockup image URL is set. */
export function CoverArt({
  className = ''
}: {
  className?: string;
}) {
  return <svg role="img" aria-label="52 Weeks of Art-Based Sessions: ready-to-run session plans for counselors and art therapists" viewBox="0 0 400 500" className={className} data-id="element-84" data-mp="35b3so3cae8gg">
      <defs data-id="element-85" data-mp="2vdy1kv3oahg8">
        <linearGradient id="cover-spine" x1="0" x2="1" data-id="element-86" data-mp="2vehaxnf9bxin">
          <stop offset="0" stopColor="#E3DCCF" data-id="element-87" data-mp="2rc493a3msjr5" />
          <stop offset="0.05" stopColor="#FCFAF5" data-id="element-88" data-mp="2rbb3wdkbm2b4" />
        </linearGradient>
        <clipPath id="cover-clip" data-id="element-89" data-mp="2mc8355bdii8y">
          <rect x="20" y="10" width="360" height="480" rx="6" data-id="element-90" data-mp="2md9qa85nyv71" />
        </clipPath>
      </defs>
      <rect x="20" y="10" width="360" height="480" rx="6" fill="url(#cover-spine)" data-id="element-91" data-mp="2hfhp0nj4pwq6" />
      <g clipPath="url(#cover-clip)" data-id="element-92" data-mp="kkbsdxx15cf8">
        <path d="M20 290 C 120 240, 200 320, 300 272 S 380 236, 380 246 L380 490 L20 490Z" fill="#E5F0EE" data-id="element-93" data-mp="kjadficw85s8" />
        <path d="M20 344 C 110 304, 230 384, 320 334 S 380 316, 380 326 L380 490 L20 490Z" fill="#EEEBF7" data-id="element-94" data-mp="yya1kdujefib" />
        <path d="M300 190 C 345 250, 300 318, 362 378 S 392 470, 392 470" stroke="#A8C29A" strokeWidth="16" fill="none" opacity="0.45" strokeLinecap="round" data-id="element-95" data-mp="12zlvuwocvowu" />
        <path d="M20 408 C 140 378, 240 448, 380 398 L380 490 L20 490Z" fill="#FCEEE4" data-id="element-96" data-mp="p1xalnqdmfr9" />
        <path d="M20 452 C 150 432, 260 478, 380 448 L380 490 L20 490Z" fill="#F0AF88" opacity="0.5" data-id="element-97" data-mp="tzpc99gtpg8n" />
        <g transform="translate(140 330) scale(1.45)" data-id="element-98" data-mp="1hp9wdvopqjji">
          <SeedPaths data-id="element-99" data-mp="1mocrooew5bea" />
        </g>
        <g stroke="#8FAE84" strokeWidth="1.6" fill="#C9DBBE" opacity="0.9" data-id="element-100" data-mp="1mmjltbc3qv7c">
          <path d="M332 300 C 322 262, 318 232, 326 200" fill="none" data-id="element-101" data-mp="17zqcqnt6elnl" />
          <ellipse cx="318" cy="278" rx="9" ry="4.5" transform="rotate(-35 318 278)" data-id="element-102" data-mp="1cy1k8rw00k2n" />
          <ellipse cx="336" cy="262" rx="9" ry="4.5" transform="rotate(35 336 262)" data-id="element-103" data-mp="1cvowfy3k7fho" />
          <ellipse cx="316" cy="244" rx="9" ry="4.5" transform="rotate(-35 316 244)" data-id="element-104" data-mp="20lj6y90eoryr" />
          <ellipse cx="334" cy="226" rx="9" ry="4.5" transform="rotate(35 334 226)" data-id="element-105" data-mp="25fnfuxt8fa2h" />
          <ellipse cx="324" cy="204" rx="8" ry="4" transform="rotate(-80 324 204)" data-id="element-106" data-mp="2f8zyjbp1qkqo" />
        </g>
      </g>
      <text fontFamily="Poppins, sans-serif" fontWeight="600" fontSize="27" fill="#26335A" data-id="element-107" data-mp="2abrfz9zzkeow">
        <tspan x="46" y="78" data-id="element-108" data-mp="25au41f5kkgvu">52 Weeks of Art-Based</tspan>
        <tspan x="46" y="112" data-id="element-109" data-mp="21atkxh7izhig">Sessions</tspan>
      </text>
      <text fontFamily="Poppins, sans-serif" fontWeight="500" fontSize="15" fill="#505B7C" data-id="element-110" data-mp="21aa6wbkzxd9p">
        <tspan x="46" y="150" data-id="element-111" data-mp="1wcrsw6s4g7uu">Ready-to-run session plans</tspan>
        <tspan x="46" y="172" data-id="element-112" data-mp="1rkgrezhqge06">for counselors &amp; art therapists</tspan>
      </text>
    </svg>;
}

/** The cover on a soft pastel "desk" panel. */
export function CoverPanel({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative overflow-hidden rounded-3xl bg-gradient-to-br from-peach-soft via-paper to-teal-soft p-8 sm:p-10 ${className}`} data-id="element-113" data-mp="1ho5ce1qrda21">
      <div aria-hidden="true" className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-lav-soft" data-id="element-114" data-mp="18lco87cvhegf" />
      <div aria-hidden="true" className="absolute -bottom-12 -right-8 h-44 w-44 rounded-full bg-sage-soft" data-id="element-115" data-mp="3ka0zh3839i3g" />
      <CoverArt className="relative mx-auto w-[78%] max-w-[340px] -rotate-2 drop-shadow-[0_28px_28px_rgba(38,51,90,0.28)]" data-id="element-116" data-mp="3p79jl9csrw7c" />
    </div>;
}